var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f_main"},[_c('div',{staticClass:"box"},[_c('router-view',{staticStyle:{"padding-bottom":"100px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }